import {
  Container,
} from './styles';

const Tag = ({ children, isNew = false }) => (
  <Container isNew={isNew}>
    {children}
  </Container>
);

export default Tag;
